// removed by extract-text-webpack-plugin
module.exports = {"text-overflow":"text-overflow___i_OVB","bread":"bread___3y-rA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Bread.less
// module id = 724
// module chunks = 3